import React, { useEffect, useState } from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import Home from './pages/Home'
import Cart from './pages/Cart'

export default function App() {
  const [cart, setCart] = useState(() => {
    try {
      const s = localStorage.getItem('cart');
      return s ? JSON.parse(s) : [];
    } catch (e) {
      return [];
    }
  });
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    setCart(prev => {
      const found = prev.find(p => p.id === product.id);
      if (found) {
        return prev.map(p => p.id === product.id ? { ...p, qty: p.qty + 1 } : p);
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };
  const updateQty = (id, qty) => {
    setCart(prev => prev.map(p => p.id === id ? { ...p, qty } : p).filter(p => p.qty > 0));
  };
  const clearCart = () => setCart([]);
  return (
    <div className="app">
      <header className="topbar">
        <Link to="/" className="logo">Mini E‑Commerce</Link>
        <nav>
          <Link to="/cart">Cart ({cart.reduce((s, i) => s + i.qty, 0)})</Link>
        </nav>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Home addToCart={addToCart} />} />
          <Route path="/cart" element={<Cart cart={cart} updateQty={updateQty} clearCart={clearCart} />} />
        </Routes>
      </main>
      <footer className="footer">Built with React — demo project (data from JSON)</footer>
    </div>
  )
}